import { render, staticRenderFns } from "./PendingCreation.vue?vue&type=template&id=0f02a56c&"
import script from "./PendingCreation.vue?vue&type=script&lang=js&"
export * from "./PendingCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports